// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bQc1KHJnDb {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.bQc1KHJnDb h4 {
  line-height: 3em;
}
.bQc1KHJnDb .wZiAXDYmuc {
  float: left;
  width: 100%;
}
.bQc1KHJnDb .YGm_d_K43s {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.bQc1KHJnDb .YGm_d_K43s:hover {
  cursor: pointer;
}
.bQc1KHJnDb .YGm_d_K43s:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.hxjWdI69eR .KqxhN5tNgj:focus {
  outline: none;
}
.hxjWdI69eR .KqxhN5tNgj.FPw9ZcPgso.hzec00WRWN {
  background: #375A88;
}
.hxjWdI69eR .KqxhN5tNgj.FPw9ZcPgso.hzec00WRWN span {
  color: #fff;
}
.hxjWdI69eR .hzec00WRWN {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.hxjWdI69eR .hzec00WRWN:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.hxjWdI69eR input {
  height: 38px;
  min-width: 220px;
}
.YGm_d_K43s.Tk3AR9gqWb {
  background: #410102;
}
.YGm_d_K43s.qNcRJCz3qq {
  background: #911318;
}
.YGm_d_K43s.fUBhJ3au9X {
  background: #D8293B;
}
.YGm_d_K43s.bS0dBmUDtH {
  background: #F2373C;
}
.YGm_d_K43s.oMj_6XUCfe {
  background: #FC4448;
}
.YGm_d_K43s.MO4T_IBqiC {
  background: #ED535E;
}
.YGm_d_K43s.BcdJWgxtn8 {
  background: #E34926;
}
.YGm_d_K43s.Jvub6fAjL7 {
  background: #FC562B;
}
.YGm_d_K43s.ICR4m5jbHW {
  background: #FC6722;
}
.YGm_d_K43s.AFg2ENPMDU {
  background: #FD7F24;
}
.YGm_d_K43s.RBRv1RJpMf {
  background: #FD8D26;
}
.YGm_d_K43s.nIZZ_NjNiH {
  background: #EC9C3E;
}
.YGm_d_K43s.SQPaOdx2y5 {
  background: #0e673a;
}
.YGm_d_K43s.u9HJEnXEwu {
  background: #208740;
}
.YGm_d_K43s.Tmy0buj1vC {
  background: #239718;
}
.YGm_d_K43s.vlQr3fPmQH {
  background: #55A84D;
}
.YGm_d_K43s.eZLAdtesbz {
  background: #4BBE5A;
}
.YGm_d_K43s.uFdidshzWJ {
  background: #0CCA6A;
}
.YGm_d_K43s.eYObW0W0dS {
  background: #0A3C64;
}
.YGm_d_K43s.rNFxQNSD6Y {
  background: #0d487a;
}
.YGm_d_K43s.BE2zVvIumg {
  background: #10538d;
}
.YGm_d_K43s.FgsDoLy5Di {
  background: #115A99;
}
.YGm_d_K43s.gf5c8VaKND {
  background: #3387E2;
}
.YGm_d_K43s.RhPe3WZJiA {
  background: #1BA9CF;
}
.YGm_d_K43s.xTsmfya0J4 {
  background: #d27c02;
}
.YGm_d_K43s.wTgjEXeEf1 {
  background: #fb9402;
}
.YGm_d_K43s.avq0hT8RJO {
  background: #FD9B30;
}
.YGm_d_K43s.l_dxkNl0gg {
  background: #FDBE2D;
}
.YGm_d_K43s.eBd3ZzMdmB {
  background: #FED831;
}
.YGm_d_K43s.AdEH5CzTxq {
  background: #FFFD38;
}
.YGm_d_K43s.C9iKddRlQd {
  background: #2D215C;
}
.YGm_d_K43s.cseIh6tcGg {
  background: #483C83;
}
.YGm_d_K43s.oqMJsoCt75 {
  background: #58518d;
}
.YGm_d_K43s.ncVwO7zM8n {
  background: #7068A9;
}
.YGm_d_K43s.D2cZhFXESA {
  background: #7f78b2;
}
.YGm_d_K43s.wqcYsRpvqS {
  background: #8f88bc;
}
.YGm_d_K43s.EV40sCHC1A {
  background: #000;
}
.YGm_d_K43s.KKHaM2kbLW {
  background: #282626;
}
.YGm_d_K43s.XkL1Wt8aMC {
  background: #242222;
}
.YGm_d_K43s.qIrgqQCHfg {
  background: #353838;
}
.YGm_d_K43s.MRQ4xwSwKD {
  background: #666;
}
.YGm_d_K43s.Cq0Erac2Gy {
  background: #999;
}
.NsXTlQJYAn {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.NsXTlQJYAn .vv3WJVkg3u {
  display: none;
}
.aOyjhGjQvD.aOyjhGjQvD {
  padding: 32px !important;
}
.aOyjhGjQvD.aOyjhGjQvD .Ask7htyKWI .NRzgz8Yb35 {
  font-size: 13px;
  font-weight: 700;
}
.aOyjhGjQvD.aOyjhGjQvD .Ask7htyKWI .tIhXHlA9qb {
  margin-bottom: 16px;
}
.aOyjhGjQvD.aOyjhGjQvD .Ask7htyKWI .tIhXHlA9qb .Z3tetcmfWQ {
  display: flex;
  font-size: 10px;
}
.aOyjhGjQvD.aOyjhGjQvD .Ask7htyKWI .tIhXHlA9qb .Z3tetcmfWQ ._e5FlhukqJ {
  flex: 1;
  font-weight: 700;
  padding: 0 12px;
}
.aOyjhGjQvD.aOyjhGjQvD .Ask7htyKWI .tIhXHlA9qb .Z3tetcmfWQ .GvtBLjTjg4 {
  flex: 2;
  display: flex;
  align-items: center;
  padding: 0 12px;
}
.aOyjhGjQvD.aOyjhGjQvD .Ask7htyKWI .tIhXHlA9qb .Z3tetcmfWQ .UT1wlJy6kB {
  flex: 1;
  display: flex;
  align-items: center;
}
.aOyjhGjQvD.aOyjhGjQvD .Ask7htyKWI .tIhXHlA9qb .Z3tetcmfWQ .fHE96PrMiv {
  font-size: 10px;
  margin-right: 8px;
}
.aOyjhGjQvD.aOyjhGjQvD .Ask7htyKWI .tIhXHlA9qb .bSHB1c5tfY {
  font-size: 11px;
  font-style: italic;
  font-weight: 400;
  padding: 0 12px;
}
.syTO9lts71 {
  min-width: 700px;
  border-radius: 8px;
}
.kpNFG6LJlW {
  background-color: #375A87;
}
.kpNFG6LJlW .vBCVxLCHBD.vBCVxLCHBD.vBCVxLCHBD {
  font-size: 20px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `bQc1KHJnDb`,
	"color-row": `wZiAXDYmuc`,
	"color-tile": `YGm_d_K43s`,
	"picker-component": `hxjWdI69eR`,
	"picker-element": `KqxhN5tNgj`,
	"active": `FPw9ZcPgso`,
	"btn": `hzec00WRWN`,
	"red-1": `Tk3AR9gqWb`,
	"red-2": `qNcRJCz3qq`,
	"red-3": `fUBhJ3au9X`,
	"red-4": `bS0dBmUDtH`,
	"red-5": `oMj_6XUCfe`,
	"red-6": `MO4T_IBqiC`,
	"orange-1": `BcdJWgxtn8`,
	"orange-2": `Jvub6fAjL7`,
	"orange-3": `ICR4m5jbHW`,
	"orange-4": `AFg2ENPMDU`,
	"orange-5": `RBRv1RJpMf`,
	"orange-6": `nIZZ_NjNiH`,
	"green-1": `SQPaOdx2y5`,
	"green-2": `u9HJEnXEwu`,
	"green-3": `Tmy0buj1vC`,
	"green-4": `vlQr3fPmQH`,
	"green-5": `eZLAdtesbz`,
	"green-6": `uFdidshzWJ`,
	"blue-1": `eYObW0W0dS`,
	"blue-2": `rNFxQNSD6Y`,
	"blue-3": `BE2zVvIumg`,
	"blue-4": `FgsDoLy5Di`,
	"blue-5": `gf5c8VaKND`,
	"blue-6": `RhPe3WZJiA`,
	"yellow-1": `xTsmfya0J4`,
	"yellow-2": `wTgjEXeEf1`,
	"yellow-3": `avq0hT8RJO`,
	"yellow-4": `l_dxkNl0gg`,
	"yellow-5": `eBd3ZzMdmB`,
	"yellow-6": `AdEH5CzTxq`,
	"purple-1": `C9iKddRlQd`,
	"purple-2": `cseIh6tcGg`,
	"purple-3": `oqMJsoCt75`,
	"purple-4": `ncVwO7zM8n`,
	"purple-5": `D2cZhFXESA`,
	"purple-6": `wqcYsRpvqS`,
	"black-1": `EV40sCHC1A`,
	"black-2": `KKHaM2kbLW`,
	"black-3": `XkL1Wt8aMC`,
	"black-4": `qIrgqQCHfg`,
	"black-5": `MRQ4xwSwKD`,
	"black-6": `Cq0Erac2Gy`,
	"picker-theme": `NsXTlQJYAn`,
	"arrow-regular": `vv3WJVkg3u`,
	"email-history-modal__root": `aOyjhGjQvD`,
	"email-history__content--container": `Ask7htyKWI`,
	"email-history__content--status": `NRzgz8Yb35`,
	"email-history__content--emails": `tIhXHlA9qb`,
	"user-email--container": `Z3tetcmfWQ`,
	"user-email--name": `_e5FlhukqJ`,
	"user-email--email": `GvtBLjTjg4`,
	"user-email--time": `UT1wlJy6kB`,
	"user-email--icon": `fHE96PrMiv`,
	"user-history__no-email--status": `bSHB1c5tfY`,
	"email-history__container": `syTO9lts71`,
	"email-history__header--root": `kpNFG6LJlW`,
	"email-history__header--title": `vBCVxLCHBD`
};
export default ___CSS_LOADER_EXPORT___;
